<template>
    <div>
        <!-- Proposal Generator Category Modal -->
        <pg-category-modal ref="PGCategoryModal" :allPGCategories="allPGCategories"/>
        <!-- Proposal Generator Category Modal End -->

        <div class="row">
            <div class="col-6">
                <div class="icon-inner-input right-side-icon">
                    <i v-if="filter.dataLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                    <input class="form-control float-left mb-2" placeholder="Search categories" @input="debounceFilter"/>
                </div>
            </div>
            <div class="col-6">
                <button class="btn btn-primary float-right mb-2" @click="openPGCategoryModal">Add New</button>
            </div>
        </div>
        <!-- Proposal Generator Category Table -->
        <table class="table table-bordered table-responsive pg-sales-tax-table">
            <thead>
            <tr>
                <th style="width: 90%; font-size: 15px; font-weight: 400;">Name</th>
                <th style="width: 10%; font-size: 15px; font-weight: 400;">Action</th>
            </tr>
            </thead>
            <tbody>
                <nested-listing v-for="item in allPGCategories" :key="item.id" :item="item" :level="0" :parent="null" />
            </tbody>
        </table>
        <!-- Proposal Generator Category Table End -->

        <!-- Remove Category Confirmation Modal -->
        <div class="modal" id="pg-remove-category-modal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete Category?</h5>
                        <button type="button" class="close" @click="closePGRemoveCategoryModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Are you sure you want to delete this category? Any products, services or categories in it will be {{ removePGCategoryLabel }}.</p>
                    </div>
                    <div class="modal-footer">
                        <button class="no-btn-properties mx-4" @click="closePGRemoveCategoryModal()">Cancel</button>
                        <button type="button" class="btn btn-danger" @click="removePGCategory">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Form from "../../../../utils/form";
import NestedListing from "../../../shared/nested-listing.vue";
import PgCategoryModal from "./modal/pg-category-modal.vue";
export default {
    name: "pg-category-settings",
    props:[],
    components: {PgCategoryModal, Multiselect, Treeselect, NestedListing},
    data() {
        return {
            allPGCategories: [],
            removePGCategoryData: {},
            removePGCategoryLabel: '',
            filter: {
                searchTimeout: null,
                dataLoading: false,
            }
        }
    },
    mounted() {
        let self = this;
        self.getAllPGCategories();

        Bus.$on('RemoveCategory', function(item, parent) {
            self.manageRemovePGCategory(item, parent);
        });
        Bus.$on('get-all-pg-categories', function() {
            self.getAllPGCategories();
        })
    },
    methods: {
        openPGCategoryModal() {
            this.$refs.PGCategoryModal.open();
        },
        openPGRemoveCategoryModal() {
            $('#pg-remove-category-modal').modal('show');
        },
        closePGRemoveCategoryModal() {
            $('#pg-remove-category-modal').modal('hide');
            this.removePGCategoryData = {};
            this.removePGCategoryLabel = '';
        },
        debounceFilter(event) {
            let self = this;
            clearTimeout(self.filter.searchTimeout);
            self.filter.searchTimeout = setTimeout(() => {
                self.getAllPGCategories(event.target.value);
            }, 700, self);
        },
        getAllPGCategories(filter = null) {
            let self = this;
            self.filter.dataLoading = true;
            axios.post(route('api.proposal-settings.category.get-all-categories'), {filter}).then(response => {
                this.allPGCategories = response.data.allCategories;
                self.filter.dataLoading = false;
            });
        },
        manageRemovePGCategory(item, parent) {
            let self = this;
            self.removePGCategoryData = item;
            self.removePGCategoryLabel = (parent && parent !== null && parent !== undefined) ? 'moved to ' + parent.label : 'uncategorized';
            self.openPGRemoveCategoryModal();
        },
        removePGCategory() {
            let self = this;
            axios.post(route('api.proposal-settings.category.remove-category'), self.removePGCategoryData).then((data) => {
                self.closePGRemoveCategoryModal();
                self.getAllPGCategories();
            }).catch((error) => {
                //
            });
        }
    },
    watch: {

    }
};
</script>

<style scoped>
.pg-sales-tax-table tbody tr td {
    font-size: 13px;
    font-weight: normal;
}
.icon-inner-input {
    position: relative;
}
.icon-inner-input .fa-spin {
    position: absolute;
    padding: 10px;
    pointer-events: none;
}
.right-side-icon .fa-spin {
    right: 0px;
}
.right-side-icon input {
    padding-right: 30px;
}
</style>
